module.exports = __webpack_public_path__ + "static/feather-5-fcde4ecee76388d0c058fe17bece6018.png";